import React from 'react'
import MainLayout from '../../containers/MainLayout'
import logo from '../../assets/images/sanfer_logo.png'

import './index.css'

const Loader = props => {
  return <MainLayout id='contact' className={``}>
    <div className='loader'>
      <div className="sanfer">
        <div className='background-loader' />
        <img src={logo} alt='SANFER LOGO' />
      </div>
    </div>
  </MainLayout>
}

export default Loader